import React, { DragEvent, Fragment, memo, useRef, useState } from 'react';

import Area from './Area';
import Button from './Button';

interface IProps {
  droppable?: boolean;
  className?: string;
  fileSelected: (file: File) => void;
  accept?: string;
  imageURL?: string;
}

const DocumentFileReader = memo<IProps>(({ droppable, accept, fileSelected, imageURL }) => {
  const [loading, setLoading] = useState(false);
  const [draggingOver, setDraggingOver] = useState(false);
  const inputRef = useRef(null);

  const handleSelectImage = () => {
    inputRef.current.click();
  };

  const loadFile = async (file: File) => {
    fileSelected(file);
  };

  const onFileSelected = async () => {
    if (!inputRef.current.files.length) return;
    setLoading(true);
    await loadFile(inputRef.current.files[0]);
    setLoading(false);
  };

  const onDropFile = (event: DragEvent<any>) => {
    event.preventDefault();
    setDraggingOver(false);
    if (loading) return;
    if (event.dataTransfer.files.length > 1) {
      return;
    }
    loadFile(event.dataTransfer.files[0]);
  };

  const onDragIn = (event: DragEvent<any>) => onDragInOut(true, event);
  const onDragOut = (event: DragEvent<any>) => onDragInOut(false, event);
  const onDragInOut = (dragging: boolean, event: DragEvent<any>) => {
    event.preventDefault();
    !(dragging === draggingOver || loading) && setDraggingOver(dragging);
  };

  return (
    <Fragment>
      {droppable ? (
        <Area
          fileSelected={fileSelected}
          draggingOver={draggingOver}
          loading={loading}
          onDropFile={onDropFile}
          onDragIn={onDragIn}
          onDragOut={onDragOut}
          onFileSelected={onFileSelected}
          handleSelectImage={handleSelectImage}
          inputRef={inputRef}
          imageURL={imageURL}
        />
      ) : (
        <Button
          loading={loading}
          onFileSelected={onFileSelected}
          handleSelectImage={handleSelectImage}
          inputRef={inputRef}
          accept={accept}
        />
      )}
    </Fragment>
  );
});

export default DocumentFileReader;
